export default __webpack_public_path__ + "static/media/Wolf@3x.bc25469b.png";